import { vueDeepSet } from "../../../../lib/utils";
import FormItem from '.';

/** @type {UICore.ComponentMeta} */
const FormItemComponentMeta = {
  id: 'w-form-item',
  name: '表单项',
  icon: 'https://vfiles.gtimg.cn/wuji_dashboard/xy/rainbow/icon-form-item_1636364019956.png',
  // 目前与表单相同
  category: '表单',
  component: FormItem,
  designerFlags: {
    allowAdjustWidth: false,
    allowAdjustHeight: false
  },
  slots: [{
    id: 'default',
    containerRef: 'editorArea'
  }],
  propsSchema: {
    type: 'object',
    fields: [{
      id: 'hideLabel',
      type: 'boolean',
      title: '隐藏标签'
    }, {
      id: 'label',
      type: 'string',
      title: '标签',
      default: '请设置标签'
    }, {
      id: 'description',
      type: 'string',
      title: '底部描述文字'
    }, {
      id: 'tooltipText',
      type: 'string',
      title: '提示 Icon 文案'
    }, {
      id: 'readonly',
      type: 'boolean',
      title: '只读',
      ui: {
        type: 'multiRatioInput'
      }
    }, {
      id: 'required',
      type: 'boolean',
      title: '必填',
      ui: {
        type: 'multiRatioInput'
      }
    }, {
      id: 'hasSuccessFeedback',
      type: 'boolean',
      title: '校验成功反馈',
      ui: {
        type: 'multiRatioInput'
      }
    }, {
      id: 'disabled',
      type: 'boolean',
      title: '禁用',
      ui: {
        type: 'multiRatioInput'
      }
    }, {
      id: 'fillLine',
      type: 'boolean',
      title: '占满整行'
    }, {
      id: 'labelWidth',
      type: 'string',
      title: '标签宽度',
      description: '留空则由表单决定，示例：100px'
    }, {
      id: 'layout',
      type: 'string',
      title: '标签水平对齐形式',
      enum: [{
        label: '由表单决定',
        value: ''
      }, {
        label: '右对齐',
        value: 'horizontal'
      }, {
        label: '顶对齐',
        value: 'vertical'
      }, {
        label: '左对齐',
        value: 'horizontal_left'
      }
      // {label:'inline'	,value:'inline'	},
      ]
    }, {
      id: 'labelVertical',
      type: 'string',
      title: '标签垂直对齐形式',
      enum: [{
        label: '继承上级',
        value: ''
      }, {
        label: '默认',
        value: 'default'
      }, {
        label: '向上对齐',
        value: 'start'
      }, {
        label: '居中',
        value: 'center'
      }, {
        label: '向下对齐',
        value: 'end'
      }]
    }, {
      id: 'titleMode',
      title: '描述&提示渲染方式',
      type: 'string',
      enum: [{
        label: '由表单决定',
        value: ''
      }, {
        value: 'default',
        label: '单行文本'
      }, {
        value: 'pre',
        label: '多行文本(PRE)'
      }, {
        value: 'markdown',
        label: 'Markdown'
      }]
    }, {
      id: 'mobileMode',
      title: '移动端渲染',
      type: 'string',
      enum: [{
        label: '自动优化布局',
        value: ''
      }, {
        value: 'manual',
        label: '遵循用户设置'
      }]
    }, {
      id: 'className',
      type: 'string',
      hidden: true
    }, {
      id: 'css',
      title: '自定义CSS',
      type: 'string',
      ui: {
        settings: {
          multipleLine: true
        }
      },
      hidden: true
    }, {
      id: 'disableMinWidth',
      title: '禁用最小宽度',
      type: 'boolean',
      hidden: true
    }]
  },
  initialLayout: {
    props: {
      disableMinWidth: true
    }
  },
  getActions({
    layout,
    replaceCompWith,
    designer,
    path,
    modifyComp
  }) {
    var _layout$props, _layout$children;
    const fillLine = !!((_layout$props = layout.props) !== null && _layout$props !== void 0 && _layout$props.fillLine);

    /** @type {UICore.ComponentDesignAction[]} */
    const ans = [{
      icon: 'fa fa-arrows-h',
      title: '撑满行',
      highlighted: fillLine,
      execute: async () => {
        await modifyComp(comp => {
          vueDeepSet(comp, 'props.fillLine', !fillLine);
        });
      }
    }, ((_layout$children = layout.children) === null || _layout$children === void 0 ? void 0 : _layout$children.length) > 0 && {
      title: '选中编辑框',
      icon: 'fa fa-edit',
      place: ['propPanel'],
      execute: () => {
        // 选中编辑框组件
        // eslint-disable-next-line
        designer.compPath = `${path}/default/0`;
      }
    }, {
      title: '移除容器',
      icon: 'fa fa-scissors',
      desc: '拆除“表单项”组件这个壳，但是保留里面的组件',
      execute: () => replaceCompWith(...(layout.children || []))
    }, {
      title: '转为卡片',
      icon: 'fa fa-list-alt',
      place: ['propPanel'],
      execute: () => {
        var _layout$props2;
        return replaceCompWith({
          type: 'w-card',
          props: {
            title: ((_layout$props2 = layout.props) === null || _layout$props2 === void 0 ? void 0 : _layout$props2.label) || ''
          },
          children: layout.children
        });
      }
    }];
    return ans.filter(Boolean);
  },
  placeCompInside() {
    return 'default';
  }
};
export default FormItemComponentMeta;
//# sourceMappingURL=meta.js.map
